@if (show) {
  <mat-progress-bar
    [mode]="mode"
  [value]="progress"></mat-progress-bar>
}